import "@/index.css";
import "./i18n";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { WalletProvider } from "./lib/wallet";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ExplorerPage from "./pages/ExplorerPage";
import AuctionsPage from "./pages/AuctionsPage";
import TokenDetailPage from "./pages/TokenDetailPage";
import MyTokensPage from "./pages/MyTokensPage";
import AdminPage from "./pages/AdminPage";
import AboutPage from "./pages/AboutPage";

const TOAST_OPTIONS = {
    style: {
        background: "#0F172A",
        border: "1px solid rgba(255,255,255,0.1)",
        color: "#F8FAFC",
        borderRadius: 0,
        fontFamily: "JetBrains Mono, monospace",
    },
};

function App() {
    return (
        <WalletProvider>
            <BrowserRouter>
                <div className="min-h-screen flex flex-col">
                    <Header />
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/explorer" element={<ExplorerPage />} />
                            <Route path="/auctions" element={<AuctionsPage />} />
                            <Route path="/token/:number" element={<TokenDetailPage />} />
                            <Route path="/my-tokens" element={<MyTokensPage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/admin" element={<AdminPage />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
                <Toaster
                    theme="dark"
                    position="bottom-right"
                    toastOptions={TOAST_OPTIONS}
                />
            </BrowserRouter>
        </WalletProvider>
    );
}

export default App;
